<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">智能锁授权申请审批</h3>
    <!-- <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
      </el-form>
    </div> -->
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column prop="created_at" fixed width="160" label="申请时间">
        </custom-table-column>
        <custom-table-column prop="applicant_name" width="120" label="申请人">
        </custom-table-column>
        <custom-table-column prop="device_name" width="120" label="设备名">
        </custom-table-column>
        <custom-table-column prop="status_text" width="100" label="审批状态">
        </custom-table-column>
        <custom-table-column prop="auth_type_text" width="100" label="密码类型">
        </custom-table-column>
        <custom-table-column prop="use_end_time" width="180" label="使用开始时间">
        </custom-table-column>
        <custom-table-column prop="use_start_time" width="180" label="使用结束时间">
        </custom-table-column>
        <custom-table-column prop="reason" min-width="220" label="使用说明">
        </custom-table-column>
        <custom-table-column label="操作" fixed="right" width="100">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status == 1" @click="handleOper(scope.row, 'approve')" type="text"
              size="small">通过</el-button>
            <el-button v-if="scope.row.status == 1" @click="handleOper(scope.row, 'reject')" type="text"
              size="small">否决</el-button>
            <el-button v-if="scope.row.status == 2" @click="handleOperCancel(scope.row.id)" type="text"
              size="small">取消授权</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="510px">
      <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item v-if="ruleForm.action == 'approve'" label="授权：" prop="auth_type"
          :rules="[{ required: true, message: '请选择', trigger: 'change' }]">
          <el-radio-group v-model="ruleForm.auth_type" style="width:216px;">
            <el-radio label="short">短期</el-radio>
            <el-radio label="long">长期</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="ruleForm.action == 'reject'" label="说明原因：" prop="remark"
          :rules="[{ required: true, message: '请输入', trigger: 'blur' }]">
          <el-input type="textarea" placeholder="请输入" :rows="4" v-model="ruleForm.remark"
            style="width:336px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" @click="submitFormByFun('ruleForm', setStatus(ruleForm))">提交</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinFormatter],
  data() {
    return {
      formInline: {
      },
      centerDialogVisible: false,
      ruleForm: {
        authorization_id: '',
        action: '',
        auth_type: '',
        remark: '',
      },
    };
  },
  components: {},
  created() { },
  mounted() {
  },
  methods: {
    handleOper(row, status) {
      this.title = '通过';
      if (status == 'reject') {
        this.title = '否决';
      }
      this.centerDialogVisible = true;
      this.ruleForm.authorization_id = row.id;
      this.ruleForm.action = status;
      this.ruleForm.auth_type = '';
      this.ruleForm.remark = '';
    },
    handleOperCancel(id) {
      this.confirmBox('warning', `此操作将取消授权，是否继续`, { authorization_id: id, action: 'cancel' }, this.setStatus);
    },
    async setStatus(params) {
      let res = await this.$api.instance.interfaceServer(`api/smart_lock/smart-lock/approve-authorization`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '处理成功！',
        });
        this.centerDialogVisible = false
        this.getList();
      }
    },
    async handleClassChange(e) {
      if (this.ruleForm.training_room_id) {
        let params = { training_room_id: this.ruleForm.training_room_id };
        params.page = 1;
        params.size = 9999;
        let res = await this.$api.instance.interfaceServer('api/training/common/room/device/list', 'get', params);
        if (res.code == 0 && res.data) {
          this.eqs = res.data.data;
        }
      } else {
        this.eq = [];
      }
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/smart_lock/smart-lock-auth/records', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}

.el-select-dropdown__item {
  height: auto !important;
  line-height: 20px;
  padding: 4px 30px;
}
</style>
